<template>
  <div>
    <template slot="title">
      <h6 class="colorEmision">Emision</h6>
      <div class="separador"></div>
    </template>
    <b-card bg-variant="light">
      <template slot="header" class="text-center">
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="2">
            <h3><b>Orden de Compra</b></h3>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="2">
            <b-input-group>
              <template v-if="seriesCargadas">
                <b-button size="md" variant="secondary" outline-success>
                  Cargando Series...
                  <i class="fa fa-spin fa-spinner"></i>
                </b-button>
              </template>
              <template v-else>
                <select class="form-control input-placedark input-dark colorBorde" v-model="indexSerie">
                  <option
                    v-for="(serie, index) in listaSeries"
                    :value="index"
                    :key="index"
                  >{{ serie }}</option>
                </select>
              </template>
            </b-input-group>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="2">
            <b-form-select class="colorBorde" v-model="moneda">
              <option
                :value="moneda"
                v-for="moneda in tipoMoneda"
                v-bind:key="moneda.id"
              >{{ moneda.descripcion }}</option>
            </b-form-select>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="2">
            <b-form-checkbox
              id="checkbox-1"
              v-model="dataitem.freesale"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
            >Orden de compra libre</b-form-checkbox>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" sm="7" md="7" lg="7" xl="7">
          <em>
            <strong>Para:</strong>
          </em>
          <br />
          <b-row align-v="center" class="mb-1">
            <b-col cols="12" sm="4" md="4" lg="4" xl="2">Documento:</b-col>
            <b-col cols="12" sm="6" md="4" lg="3" xl="3">
              <b-form-select class="colorBorde" v-model="tipoDocumento">
                <option
                  :value="tipodocumento.tipo"
                  v-for="tipodocumento in documentosIdentidad"
                  v-bind:key="tipodocumento.tipo"
                >{{ tipodocumento.nombre }}</option>
              </b-form-select>
            </b-col>
            <b-col cols="12" sm="8" md="8" lg="8" xl="6">
              <b-input-group>
                <b-form-input
                  v-model="receptor.numero"
                  class="text colorBorde"
                  placeholder="Ingrese numero de documento (*)"
                  @change="getReceivers(1)"
                ></b-form-input>
                <b-input-group-text class="colorBorde" slot="append">
                  <b-button
                    size="sm"
                    variant="warning"
                    class="m-0 p-0"
                    @click="enableFieldsReceptor"
                  >
                    <i class="fa fa-search ml-1 mr-1"></i>
                  </b-button>
                </b-input-group-text>
              </b-input-group>
              <template v-if="cargandoreceptor">
                <b-list-group class="searcher-field">
                  <b-list-group-item>
                    Buscando
                    <i class="fa fa-spin fa-spinner"></i>
                  </b-list-group-item>
                </b-list-group>
              </template>
              <b-list-group v-if="listarec" class="searcher-field">
                <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                  <b-list-group-item
                    :key="index"
                    @click="setReceiver(item)"
                    class="searcher-result"
                  >{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                </template>
              </b-list-group>
              <b-list-group v-if="mostrardni" class="searcher-field">
                  <b-list-group-item v-if="norecdni">No hay Receptores con ese número</b-list-group-item>                                 
                  <template >
                    <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                  </template> 
                </b-list-group> 
            </b-col>
          </b-row>
          <b-row align-v="center" class="mb-1">
            <b-col cols="12" sm="4" md="4" lg="4" xl="2">Razon Social:</b-col>
            <b-col cols="12" sm="8" md="8" lg="8" xl="9">
              <b-input
                v-model="receptor.razonSocial"
                @change="getReceivers(2)"
                placeholder="Ingresa razon social (*)"
                class="colorBorde"
              ></b-input>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col cols="12" sm="4" md="4" lg="4" xl="2">Direccion:</b-col>
            <b-col cols="12" sm="8" md="8" lg="8" xl="9">
              <b-input-group>
                <b-form-input
                  class="colorBorde"
                  type="text"
                  v-model="receptor.direccion"
                  :value="receptor.direccion"
                  placeholder="Ingrese Dirección (*)"
                ></b-form-input>
                <b-input-group-text class="colorBorde" slot="append">
                  <button class="btn btn-warning btn-sm sinresultados" @click="changeDirection()">
                    <i class="fa fa-list"></i>
                  </button>
                </b-input-group-text>
              </b-input-group>
              <template v-if="verDirecciones">
                <template v-for="(item, index) in direcciones" class="buscarRuc">
                  <b-list-group-item
                    :key="index"
                    @click="setDirection(item)"
                    class="searcher-result"
                  >{{item.direccion}}</b-list-group-item>
                </template>
              </template>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" sm="5" md="5" lg="5" xl="5">
          <em>
            <strong>Detalles:</strong>
          </em>
          <br />
          <b-row align-v="center" class="mb-1">
            <b-col cols="12" sm="7" md="7" lg="8" xl="12">
              <div class="form-label-group">
              <input 
                type="text"
                class="form-control address colorBorde"
                placeholder="Plazo de entrega" 
                v-model="plazoentrega">
                <label>Plazo de entrega:</label>
              </div>
            </b-col>
          </b-row>
          <b-row align-v="center" class="mb-1">
            <b-col cols="12" sm="7" md="7" lg="8" xl="4">
              <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" v-model="formapago">
                <option
                  :value="fpago"
                  v-for="fpago in formaPago"
                  v-bind:key="fpago.codigo"
                >{{ fpago.nombre }}</option>
              </select>
            </b-col>
            <b-col>
               <div class="form-label-group">
                <input 
                  type="text"
                  class="form-control address colorBorde" 
                  v-model="garantia" 
                  placeholder="Garantia">
                  <label>Garantia</label>
               </div>
            </b-col>
            <b-col>
               <div class="form-label-group">
                <input
                  maxlength="9"
                  type="text"
                  class="form-control address colorBorde" 
                  v-model="telefono" 
                  placeholder="Teléfono">
                  <label>Teléfono</label>
               </div>
            </b-col>
          </b-row>
          <!-- <b-row align-v="center">
            <b-col cols="12" sm="5" md="5" lg="4" xl="3">Condición de pago:</b-col>
            <b-col cols="12" sm="7" md="7" lg="8" xl="8">
              <b-form-input v-model="validez"></b-form-input>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col cols="12" sm="5" md="5" lg="4" xl="3">Adicional 1:</b-col>
            <b-col cols="12" sm="7" md="7" lg="8" xl="3">
              <b-form-input v-model="adicional1"></b-form-input>
            </b-col>
            <b-col cols="12" sm="5" md="5" lg="4" xl="2">Adicional 2:</b-col>
            <b-col cols="12" sm="7" md="7" lg="8" xl="3">
              <b-form-input v-model="adicional2"></b-form-input>
            </b-col>
          </b-row> -->
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <items @captureitem="insertItem" :dataitem="dataitem" :igvGlobal="igvGlobal"></items>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <template>
            <div>
              <b-table
                responsive
                :small="small"
                :striped="striped"
                :outlined="outlined"
                :items="items"
                :fields="fields"
              >
                <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                <template slot="valorVentaVista" slot-scope="row">
                  {{(row.item.montoTotalImpuestosItem + row.item.valorVenta).toFixed(2)}}
                </template>
                <template slot="acciones" slot-scope="row">
                  <b-button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></b-button>
                  <b-button
                    class="btn btn-sm btn-group btn-outline-danger"
                    @click="deleteItem(row.index)"
                  >
                    <i class="fa fa-trash danger"></i>
                  </b-button>
                </template>
                  <template slot="muestraIgv" slot-scope="row">
                      <p style="color:red; font-size:10px;margin:0px;padding: 0px;">{{ row.item.porcentajeImpuesto }}%</p>
                  </template>
              </b-table>
            </div>
          </template>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="0" sm="0" md="8" lg="8" xl="8">
          <b-form-textarea
            v-model="observaciones"
            rows="3"
            max-rows="6"
            class="textareaproforma colorBorde"
            placeholder="Observaciones... "
          ></b-form-textarea>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <totales @loadtotal="insertTotal" :items="items" :monedabuffer="moneda" :identificadorPro="identificadorPro"></totales>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" sm="6" md="8" lg="8" xl="9"></b-col>
        <b-col cols="4" sm="3" md="2" lg="2" xl="2">
          <template v-if="update">
            <button
              v-if="!cargandoordencompra"
              class="btn btn-primary botonesemitir"
              :disabled="validateOrdenCompra()"
              @click.prevent="sendOrdenCompra()"
            >
              <i class="fa fa-save"></i> Guardar
            </button>
            <button v-else class="btn btn-seconday botonesemitir">
              <i class="fa fa-spin fa-spinner"></i> Guardando...
            </button>
          </template>
          <template v-else>
            <button
              v-if="!actualizandoordencompra"
              class="btn btn-warning botonesemitir"
              @click.prevent="updateOrdenCompra"
            >
              <i class="fa fa-save"></i> Actualizar
            </button>
            <button v-else class="btn btn-seconday botonesemitir">
              <i class="fa fa-spin fa-spinner"></i> Actualizando...
            </button>
          </template>
        </b-col>
      </b-row>
    </b-card>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import axios from "axios";
import Items from "@/components/comunes/Items";
import Totales from "@/components/comunes/Totales";
import { TipoMoneda } from "@/shared/utils";
import { DocumentosIdentidadConductor } from "@/shared/utils";
export default {
  name: "ordenCompraEmision",
  props: ["changeOrdenCompra"],
  components: {
    Items,
    Totales
  },
  data: () => {
    return {
      formaPago: [
        { codigo: 1, nombre: "Contado" },
        { codigo: 2, nombre: "Crédito" },
        { codigo: 3, nombre: "Transferencia" },
        { codigo: 4, nombre: "Cheque" },
        { codigo: 5, nombre: "Canje" }
      ],
      adicional1: "",
      adicional2: "",
      validez: "",
      direcciones: [],
      listaCorreos: [],
      verDirecciones: false,
      documentosIdentidad: DocumentosIdentidadConductor,
      tipoDocumento: 6,
      small: true,
      striped: true,
      outlined: true,
      update: true,
      tipoMoneda: TipoMoneda,
      cargandoreceptor: false,
      receptor: {
        numero: "",
        tipo: "6",
        direccion: "",
        razonSocial: "",
        direccionFiscal: ""
      },
      moneda: {
        id: "1",
        codigo: "PEN",
        descripcion: "SOLES",
        simbolo: "S/."
      },
      condicionpago: "",
      plazoentrega: "",
      formapago: { codigo: 1, nombre: "Contado" },
      garantia: "",
      telefono: "",
      observaciones: "",
      serie: "",
      numero: "",
      captureitem: false,
      ordencompra: {
        emisor: {
          nro: "",
          razonSocial: ""
        },
        receptor: {
          tipo: "",
          nro: "",
          razonSocial: "",
          direccionFiscal: ""
        },
        adicional: {
          tipo_igv:''
        },
        moneda: "",
        plazoentrega: "",
        formapago: "",
        garantia: "",
        telefono: "",
        observaciones: ""
      },
      fields: [
        { key: "index", label: "Item" },
        { key: "cantidad", label: "Cantidad", sortable: true },
        { key: "descripcion", label: "Descripción", sortable: true },
        { key: "valorUnitarioVista", label: "Valor Unitario", sortable: true },
        { key: "descuento", label: "Descuento", sortable: true },
        { key: "montoAfectacionIgv", label: "Igv", sortable: true },
        { key: "valorVentaVista", label: "Precio Total", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true },
        { key: "muestraIgv", label: "", sortable: true }
        
      ],
      items: [],
      dataitem: {
        estado: false, // Bandera logica de si se esta usando este arreglo
        tipo: 1, // 1: actualizar; 2: borrar; 3: cargar masiva
        index: 0, // Posicion en el array para actualizar o borrar
        // data: [],       // Lista de items
        item: {}, // Item unitario para actualizar o borrar
        idReceptor: "", // Para la busqueda de productos por receptor (OC)
        // ordencompra: 1  // 0: busqueda de items normal; 1: busqueda de items por receptor
        freesale: '0'
      },
      totales: {},
      rucValid: null,
      listarec: true,
      norec: false,
      listaReceptores: [],
      listaSeries: [],
      indexSerie: 0,
      tipodoc: "10",
      seriesCargadas: false,
      cargandoordencompra: false,
      actualizandoordencompra: false,
      idProforma: "",
      mostrardni:false,
      norecdni:false,
      listadni:[],
      identificadorPro: 0,
      igvGlobal: null
    }
    
  },
  mounted() {
    this.initChangeOrdenCompra(), this.getSeries();
  },
  watch: {
    "receptor.numero": function() {
      if (this.receptor.numero.length > 7) {
        this.dataitem.tipo = 3;
        this.dataitem.estado = false;
        this.dataitem.idReceptor = this.receptor.numero;
      } else if (this.receptor.numero.length == 0) {
        this.receptor.numero = "";
        this.receptor.razonSocial = "";
        this.receptor.direccion = "";
        this.receptor.direccionFiscal = "";
        this.dataitem.idReceptor = "";
        this.listarec = false;
      }
    }
  },
  methods: {
    validateOrdenCompra: function() {
      let tiposerie = "";
      if (this.indexSerie == 0) {
        this.serie = this.listaSeries[0];
        tiposerie = this.serie;
      } else {
        this.serie = this.listaSeries[this.indexSerie];
        tiposerie = this.serie;
      }
      if (
        this.receptor.numero != "" &&
        this.receptor.razonSocial != "" &&
        this.items.length > 0 &&
        tiposerie !== ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    getSeries: function() {
      this.identificadorPro
      this.seriesCargadas = true;
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/series/9", {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
            (this.listaSeries = response.data.data),
            (this.rolSeries = response.data.rol),
            (this.seriesCargadas = false),
            this.igvGlobal = response.data.igv,
            console.log('igv en proforma', response.data.igv)
          )
        )
        .catch(error => {
          this.seriesCargadas = false;
        });
    },
    initItems: function() {
      let itemBlank = [];
      this.$store.commit("setitems", itemBlank);
    },
    setDirection: function(value) {
      (this.receptor.direccion = value.direccion),
        (this.verDirecciones = false);
    },
    enableFieldsReceptor: function() {
      this.habilitado = false;
    },
    changeDirection: function() {
      this.verDirecciones = !this.verDirecciones;
    },
    initChangeOrdenCompra: function() {
      let validatobjeto = false;
      Object.keys(this.changeOrdenCompra).length === 0
        ? (validatobjeto = true)
        : (validatobjeto = false);
      if (!validatobjeto) {
        (this.receptor.numero = this.changeOrdenCompra.ordenCompra.receptor.nro),
          (this.receptor.razonSocial = this.changeOrdenCompra.ordenCompra.receptor.razonSocial),
          (this.receptor.direccion = this.changeOrdenCompra.ordenCompra.receptor.direccionFiscal),
          (this.idOrdenCompra = this.changeOrdenCompra.idOrdenCompra),
          (this.plazoentrega = this.changeOrdenCompra.ordenCompra.plazoentrega),
          (this.formapago = this.changeOrdenCompra.ordenCompra.formapago),
          (this.observaciones = this.changeOrdenCompra.ordenCompra.observaciones),
          (this.garantia = this.changeOrdenCompra.ordenCompra.garantia),
          (this.telefono = this.changeOrdenCompra.ordenCompra.telefono),
          (this.items = this.changeOrdenCompra.ordenCompra.items),
          this.$store.commit("setitems", this.items);
        // this.dataitem.data = this.changeOrdenCompra.ordenCompra.items,
        (this.dataitem.estado = false),
          (this.dataitem.tipo = 3),
          (this.dataitem.index = 0),
          // this.dataitem.ordencompra = 1,
          (this.dataitem.idReceptor = this.receptor.numero),
          (this.update = false);
      } else {
        (this.update = true), this.initOrdenCompra(), this.initItems();
      }
    },
    insertItem: function(value) {
      this.$store.commit("setitems", value);
      this.items = this.$store.getters.getitems;
      this.dataitem.tipo = 3;
      this.dataitem.estado = false;
      this.dataitem.idReceptor = this.receptor.numero;
    },
    insertTotal: function(value) {
      if (value) {
        this.totales = value;
      }
    },
    updateItem: function(index, item) {
      this.dataitem.estado = true;
      this.dataitem.tipo = 1;
      this.dataitem.index = index;
      this.dataitem.item = item;
      this.dataitem.idReceptor = this.receptor.numero;
    },
    deleteItem: function(index) {
      this.dataitem.estado = true;
      this.dataitem.tipo = 2;
      this.dataitem.index = index;
      this.dataitem.idReceptor = this.receptor.numero;
    },
    sendOrdenCompra: function() {
      let itemBlank = [];
      this.cargandoordencompra = true;
      if (this.loadOrdenCompra()) {
        axios
          .post(process.env.VUE_APP_API_URL + "ordencompra/insertar", {
            token: this.$store.getters.userToken,
            serie: this.serie,
            ordencompra: this.ordencompra
          })
          .then(
            response => (
              this.$snotify.success(response.data.msg, "Exito"),
              (this.cargandoordencompra = false),
              this.initOrdenCompra(),
              this.changeTab(3),
              this.$store.commit("setitems", itemBlank)
            )
          )
          .catch(error => {
            (this.cargandoordencompra = false),
              this.$snotify.error(error.response.data.msg, "Error");
          });
      }
    },
    loadOrdenCompra: function() {
      (this.ordencompra.emisor.nro = this.$store.getters.userData.cuenta.idEmisor),
        (this.ordencompra.emisor.razonSocial = this.$store.getters.userData.cuenta.razonSocial),
        (this.ordencompra.receptor.tipo = this.tipoDocumento);
      this.ordencompra.receptor.nro = this.receptor.numero;
      this.ordencompra.receptor.razonSocial = this.receptor.razonSocial;
      this.ordencompra.receptor.direccionFiscal = this.receptor.direccion;
      this.ordencompra.origen = 1; // 1: Orden Compra; 2: Toma Pedido; 3: Web
      this.ordencompra.credito = this.formapago;
      this.ordencompra.cantidaditems = this.items.length;
      this.ordencompra.moneda = this.moneda;
      this.ordencompra.plazoentrega = this.plazoentrega;
      this.ordencompra.formapago = this.formapago;
      this.ordencompra.garantia = this.garantia;
      this.ordencompra.telefono = this.telefono;
      this.ordencompra.items = this.items;
      this.ordencompra.totales = this.totales;
      this.ordencompra.observaciones = this.observaciones;
      this.ordencompra.adicional.username = this.$store.getters.userData.username;
      this.ordencompra.adicional.tipo_igv = this.igvGlobal
      return true;
    },
    initOrdenCompra: function() {
      (this.ordencompra.emisor.nro = ""),
        (this.ordencompra.emisor.razonSocial = ""),
        (this.ordencompra.receptor.tipo = "");
      this.ordencompra.receptor.nro = "";
      this.ordencompra.receptor.razonSocial = "";
      this.ordencompra.receptor.direccionFiscal = "";
      this.ordencompra.moneda = "";
      this.ordencompra.plazoentrega = "";
      this.ordencompra.formapago = "";
      this.ordencompra.garantia = "";
      this.ordencompra.telefono = "";
      this.ordencompra.observaciones = "";
      this.ordencompra.adicional = {};
      this.tipoDocumento = 6;
      return true;
    },
    updateOrdenCompra: function() {
      (this.actualizandoordencompra = true), this.loadOrdenCompra();
      axios
        .post(process.env.VUE_APP_API_URL + "ordencompra/actualizar", {
          token: this.$store.getters.userToken,
          id: this.idOrdenCompra,
          ordencompra: this.ordencompra
        })
        .then(
          response => (
            (this.actualizandoordencompra = false),
            this.$snotify.success(response.data.msg, "Exito"),
            this.initOrdenCompra(),
            this.changeTab(3)
          )
        )
        .catch(error => {
          (this.actualizandoordencompra = false),
            this.$snotify.error(error.response.data.msg, "Error");
        });
    },
    printOrdenCompra: function() {},
    getReceivers: function(value) {
      this.listaReceptores = [];
      let link = "";
      let cadenabusqueda = "";
      if (value === 1) {
        (link = "receptores/listaconterceros"),
          (cadenabusqueda = this.receptor.numero);
      } else if (value === 2) {
        link = "receptores/listaconterceros/razonsocial";
        cadenabusqueda = this.receptor.razonSocial;
      }
      this.cargandoreceptor = true;
      this.listarec = true;
      this.norec = false;
      axios
        .post(process.env.VUE_APP_API_URL + link, {
          token: this.$store.getters.userToken,
          q: cadenabusqueda,
          tipoRec: this.tipoDocumento
        })
        .then(
          response => (
            (this.listaReceptores = response.data),
            (this.cargandoreceptor = false),
            this.receivercount(this.listaReceptores.length)
          )
        )
        .catch(error => (this.cargandoreceptor = false));
    },
    setReceiver: function(item) {
      (this.receptor.numero = item.idReceptor),
        (this.receptor.tipo = item.tipo),
        (this.receptor.razonSocial = item.razonSocial),
        (this.receptor.direccion = item.direccionReferencia),
        (this.direcciones = item.direcciones),
        (this.listaCorreos = item.email),
        (this.listarec = false),
        (this.listaReceptores = []),
        (this.tipoDocumento = item.tipo);
    },
    addReceiver: function(value) {
      if (value.length == 0) {
        this.modalCliente = true;
      } else {
        this.modalCliente = false;
      }
    },
    receivercount: function(value) {
      if (!value){
        // this.$snotify.warning(
        //   "No se encontró al receptor, ingrese el RUC completo ó agreguelo como nuevo cliente",
        //   "Atención"
        // );
        this.searchDNI();
      }
    },
    searchDNI(){
            this.cargandoreceptor = true
            this.mostrardni = true
            this.norecdni = false
            axios
            .get(process.env.VUE_APP_API_URL +'v2/dni',{
                params:{
                    token: this.$store.getters.userToken,
                    dni: this.receptor.numero
                }
            })
            .then(response => (
                    this.listadni = response.data,
                    this.cargandoreceptor = false,
                    this.receivedni(this.listadni)
            ))
            .catch(error => (
                this.cargandoreceptor = false
            ))    
            
        },
    receivedni: function (value){
      if(!value){
          this.mostrardni = false
          this.norecdni = true
      }else{
          this.mostrardni = true
          this.norecdni = false
      }
    },
    setReceiverdni(item){
            this.receptor.razonSocial = item.nombre
            this.mostrardni = false
            this.listarec = false
            this.listaReceptores = []
        },
    stateReceptorRuc(value) {
      let expreg = new RegExp("\\s|<|>|[A-Za-z]|^[3-9]|^[0]");
      if (value.length == 0) {
        // this.$snotify.error('RUC Inválido','Error');
        this.rucValid = false;
      } else if (expreg.test(value)) {
        this.$snotify.error("RUC Inválido", "Error");
        this.rucValid = false;
      } else {
        this.rucValid = true;
      }
    },
    changeTab: function(value) {
      this.$emit("tabindex", value);
    }
  }
};
</script>

<style scoped>
.address{
      height: 35px !important;
      margin: 0 !important;
    }
 .form-label-group {
  position: relative;
  /* margin-bottom: 1rem; */
}

.form-label-group > input,
.form-label-group > label {
  height: 3.125rem;
  padding: .75rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 9px;
  color: #00B261;
}
.btnguardar {
  margin-right: 10px;
}
.textareaproforma {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: #000;
}
.colorBorde{
  border-color:#7e8fb9;
}
</style>